module.exports = __webpack_public_path__ + "static/media/section1-image1.0c7c2dc0.webp";